import { render, staticRenderFns } from "./EditIps.vue?vue&type=template&id=0329eaaa&"
import script from "./EditIps.vue?vue&type=script&lang=js&"
export * from "./EditIps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports